import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  return (
    <section
      id="about"
      className="relative w-full bg-[#E9E3D5] flex items-center justify-center 
                 py-[4vh] px-[3vw] font-[Poppins] border-b border-[#2D435B]/30 overflow-hidden"
    >
      {/* === Background gradasi lembut === */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#E9E3D5] via-[#E9E3D5]/95 to-[#D8D0C0] opacity-90 -z-10"></div>

      {/* === Kontainer utama === */}
      <div
        className="flex flex-row items-center justify-between w-full gap-[6vw] flex-nowrap max-w-[1300px]
                   scale-[0.95] sm:scale-[0.95] md:scale-100 origin-center transition-transform duration-300"
      >
        {/* === Kiri: Teks === */}
        <div
          className="flex-1 text-[#2D435B] flex flex-col justify-center text-left 
                     space-y-[2.5vh] min-w-[200px] max-w-[500px] 
                     pl-[1vw] sm:pl-[2vw] md:pl-[3vw] pr-[2vw] sm:pr-[3vw]"
        >
          <h2
            className="font-extrabold leading-tight 
                       text-[clamp(1.2rem,5vw,6rem)]"
          >
            Who We Are
          </h2>

          <p
            className="font-small leading-relaxed 
                      text-[clamp(0.55rem,0.85vw,0.95rem)] 
                      max-w-[80vw] sm:max-w-[55vw] md:max-w-[36vw] min-w-[220px]"
          >
            PT Asri Mandiri Kreasindo adalah perusahaan yang telah berpengalaman
            lebih dari 13 tahun dalam bidang desain struktur, mulai dari gedung
            rendah, gedung tinggi (high rise building), hingga jembatan dan
            dermaga. Dengan sertifikasi SKK grade 9, kami berkomitmen menghadirkan
            desain yang kokoh, aman, dan berkualitas.
          </p>

          <button
            onClick={() => navigate("/about-detail")}
            className="bg-[#2D435B] text-white rounded-full shadow-md 
                      hover:bg-[#1E2E40] transition-all duration-300 
                      w-fit px-[1.7vw] py-[0.8vh] 
                      text-[clamp(0.6rem,0.8vw,0.9rem)] font-medium"

          >
            Read More...
          </button>
        </div>

        {/* === Kanan: Video Vertikal 9:16 === */}
        <div className="flex justify-center flex-1">
          <div
            className="relative overflow-hidden rounded-2xl shadow-xl border border-[#2D435B]/20 
                       w-[clamp(130px,22vw,340px)] aspect-[9/16] flex justify-center items-center"
          >
            <video
              src="/video.mp4"
              className="object-cover object-center w-full h-full transition-transform duration-300 hover:scale-[1.03]"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </div>
      </div>
    </section>
  );
}
